import React from 'react';

import SkeletonRoot from '../ui/SkeletonRoot';

import { AdminDashboardLayoutSkeleton } from './dashboardChartSkeletons';



interface AdminDashboardSkeletonProps {

  loadingLabel?: string;

}



/**

 * Layout-faithful admin dashboard skeleton — stat tiles, 2x2 chart grid, list widgets.

 */

const AdminDashboardSkeleton: React.FC<AdminDashboardSkeletonProps> = ({

  loadingLabel = 'Loading dashboard',

}) => (

  <SkeletonRoot loadingLabel={loadingLabel}>

    <AdminDashboardLayoutSkeleton />

  </SkeletonRoot>

);



export default AdminDashboardSkeleton;

